// extracted by mini-css-extract-plugin
module.exports = {"relatedQuestion":"RelatedQuestions_relatedQuestion__fLzXZ"};